<template>
  <FormControl
    :required="required"
    :label="label"
    :indent="indent"
    @disabled="onSetDisabled"
  >
  <div class="box" :style="(showPreview) ? `background: url(${imagePreview}) no-repeat; background-size: cover; min-width: 14em; height: 9em; border:none;` : ``">
    <a v-on:click="resetFileUpload()" v-if="showPreview" class="close"><span>&#x2715;</span></a>
    <input
      :model="model"
      :id="`file_${name}`"
      :ref="name"
      accept="image/*"
      v-on:change="handleFileUpload()"
      type="file"
      class="inputfile inputfile-2"
      capture
    />
    <label :for="`file_${name}`" v-if="!showPreview">
      <figure>
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          height="30"
          viewBox="0 0 122.88 90.78"
          style="enable-background: new 0 0 122.88 90.78"
          xml:space="preserve"
        >
          <path
            style="fill: #0080c9"
            class="st0"
            d="M46.86,0.05h43.63l9.94,17.7h20.48c1.09,0,1.98,0.92,1.98,1.98v69.08c0,1.06-0.91,1.98-1.98,1.98H1.98 C0.92,90.78,0,89.89,0,88.81l0-69.08c0-1.09,0.89-1.98,1.98-1.98h9.21V11.4h11.38v6.35h12.36c2.57-5.08,5.14-10.15,7.71-15.23 C44.2-0.57,43.34,0.05,46.86,0.05L46.86,0.05z M110.07,26.5c3.26,0,5.9,2.64,5.9,5.9c0,3.26-2.64,5.9-5.9,5.9 c-3.26,0-5.9-2.64-5.9-5.9C104.18,29.14,106.82,26.5,110.07,26.5L110.07,26.5L110.07,26.5z M66.64,33.37 c9.87,0,17.88,8.01,17.88,17.88c0,9.87-8.01,17.88-17.88,17.88c-9.87,0-17.88-8.01-17.88-17.88 C48.76,41.38,56.77,33.37,66.64,33.37L66.64,33.37z M66.64,21.73c16.31,0,29.53,13.22,29.53,29.53c0,16.3-13.22,29.53-29.53,29.53 c-16.3,0-29.53-13.23-29.53-29.53C37.12,34.95,50.34,21.73,66.64,21.73L66.64,21.73z"
          />
        </svg>
      </figure>
      {{ lang.image_label }}<br /><strong>{{ lang.images_type[name] }}</strong>
    </label>
  </div>
  </FormControl>
</template>

<script>
import FormControl from "./FormControl";
import formControlMixin from "./mixins/form-control.mixin.js";
import ContractCustomerSignOffService from "@/services/ContractCustomerSignOffService";
let contractCustomerSignOffService;

export default {
  components: {
    FormControl,
  },
  props: [
    "required",
    "indent",
    "label",
    "placeholder",
    "model",
    "name",
    "containerClass",
    "loading",
    "disabled",
    "minHeight",
  ],
  mixins: [formControlMixin],
  /*
    Defines the data used by the component
  */
  data() {
    return {
      file: "",
      showPreview: false,
      imagePreview: "",
      lang: i18n.app.components.customer_sign_off,
    };
  },

  mounted() {
    contractCustomerSignOffService = new ContractCustomerSignOffService(this.model.hash);
  },

  methods: {
    /*
        Submits the file to the server
      */
    submitFile() {
      /*
        Initialize the form data
      */
      let formData = new FormData();
      const me = this;

      /*
        Add the form data we need to submit
      */

      formData.append("file", this.file);
      formData.append("contract_id", this.model.contract_id);
      formData.append("vehicle_id", this.model.vehicle_id);

      contractCustomerSignOffService.uploadImage(formData).then((data) => {
        me.model.files[this.name] = JSON.stringify(data);
        this.$emit("upload-ready", this.name);
      }).catch(() => {
        this.showPreview = false;
        this.imagePreview = null;
      });

    },
    resetFileUpload() {
      this.showPreview = false;
      this.imagePreview = null;
    },
    /*
      Handles a change on the file upload
    */
    handleFileUpload() {
      /*
        Set the local file variable to what the user has selected.
      */
      this.file = this.$refs[this.name].files[0];

      /*
        Initialize a File Reader object
      */
      let reader = new FileReader();

      /*
        Add an event listener to the reader that when the file
        has been loaded, we flag the show preview as true and set the
        image to be what was read from the reader.
      */
      reader.addEventListener(
        "load",
        function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );

      /*
        Check to see if the file is not empty.
      */
      if (this.file) {
        /*
          Ensure the file is an image file.
        */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          /*
            Fire the readAsDataURL method which will read the file in and
            upon completion fire a 'load' event which we will listen to and
            display the image in the preview.
          */
          reader.readAsDataURL(this.file);
          this.submitFile();
        }
      }
    },
  },
};
</script>

<style scoped>

.required {
  display: none;
}
.box {
  /*flex-shrink: 1;*/
  border: 2px dashed #bfbfbf;
  text-align: center;
  border-radius: 10px;
  margin-top: 20px;
  position: relative;
 /* min-width: 16%;
  height: 8em;
  */
  padding: 20px;
}


@media only screen and (max-width: 768px) {
  .box {
     width: 290px;
  }
}


.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

a.close {
  border-radius: 50%;
  border: solid 2px lightgray;
  background: black;
  position: absolute;
  right: 0.3em;
  top: 0.3em;
  width: 1.3em;
  height: 1.3em;
  font-size: 2.1em;
  color: white;
  text-align: center;
}

a.close span {
  position: absolute;
  top: 0.37em;
  left: 0.48em;
  font-size: 0.7em;
  color: white;
}

.inputfile + label {
  cursor: pointer;
}

</style>